import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const CheckBoxTickOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Path
      d="M16.02 3H7.98C5.24 3 3 5.24 3 7.98v8.04C3 18.76 5.24 21 7.98 21h8.04c2.74 0 4.98-2.24 4.98-4.98V7.98C21 5.24 18.76 3 16.02 3Zm3.18 13.02c0 1.75-1.43 3.18-3.18 3.18H7.98c-1.75 0-3.18-1.43-3.18-3.18V7.98c0-1.75 1.43-3.18 3.18-3.18h8.04c1.75 0 3.18 1.43 3.18 3.18v8.04Z"
      fill={color}
    />
    <Path
      d="m14.99 8.71-4.75 4.75-1.69-1.69a.9.9 0 0 0-1.27 0 .9.9 0 0 0 0 1.27l2.33 2.33c.17.17.4.26.64.26a.9.9 0 0 0 .64-.26l5.38-5.38a.9.9 0 0 0 0-1.27.9.9 0 0 0-1.27 0l-.01-.01Z"
      fill={color}
    />
  </Svg>
)

export default CheckBoxTickOutlined
